import { UploadIcon } from 'lucide-react';
import { cn } from '@rocco/utils/cn';

/**
 * Overlay displayed when files are dragged over the chat details / chat box,
 * indicating that the user can drop files to upload them.
 * @see {@link ChatDetails}
 * @see {@link ChatBox}
 */
export function ChatDropOverlay({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                'absolute inset-0 z-10 flex flex-col items-center justify-center gap-[8px] rounded-[inherit] bg-black/70',
                className,
            )}
        >
            <UploadIcon className="size-[24px] text-white/80" />
            <span className="text-center text-[16px] leading-tight font-semibold text-white">
                Drop files here
            </span>
        </div>
    );
}
